var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercent02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 4.16699L4.1665 15.8337M7.49984 5.83366C7.49984 6.75413 6.75365 7.50033 5.83317 7.50033C4.9127 7.50033 4.1665 6.75413 4.1665 5.83366C4.1665 4.91318 4.9127 4.16699 5.83317 4.16699C6.75365 4.16699 7.49984 4.91318 7.49984 5.83366ZM15.8332 14.167C15.8332 15.0875 15.087 15.8337 14.1665 15.8337C13.246 15.8337 12.4998 15.0875 12.4998 14.167C12.4998 13.2465 13.246 12.5003 14.1665 12.5003C15.087 12.5003 15.8332 13.2465 15.8332 14.167Z",
    stroke: "#8B8B8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent02);
export default __webpack_public_path__ + "static/media/percent-02.5a10780dafbce68168d218637c91c95c.svg";
export { ForwardRef as ReactComponent };